<form (ngSubmit)="inputForm.valid && onSubmit()" [formGroup]="inputForm" novalidate>
  <h2 mat-dialog-title>
    {{title | translate}}
  </h2>
  <mat-dialog-content class="content-padding">
    <lina-message *ngIf="infoMessage" content="{{infoMessage}}"
                  theme="info"></lina-message>
    <div *ngIf="body">{{body | translate}}</div>
    <div *ngIf="htmlBody" [innerHTML]="htmlBody"></div>   
  </mat-dialog-content>
  <div class="lina-input-container">
    <mat-form-field>
      <input *ngIf="!textarea" matInput name="input" [type]="type" [attr.inputmode]="inputMode" formControlName="Input" placeholder="{{placeholder | translate}}" required="{{required}}">
      <textarea *ngIf="textarea" cdkTextareaAutosize matInput name="input" formControlName="Input" placeholder="{{placeholder | translate}}" required="{{required}}"></textarea>
      <mat-error lina-form-errors target="input"></mat-error>
    </mat-form-field>
  </div>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close type="button">{{'CANCEL' | translate}}</button>
    <button mat-button type="submit" color="primary">{{'SEND' | translate}}</button>
  </mat-dialog-actions>
</form>
